import React, { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MedFrequencyTable from './MedFrequencyTable.js';
import EditMedFreqModal from './EditMedFreqModal.js';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb.js';
import paths from 'routes/paths.js';

const MedFrequency = () => {
    const [trigger, setTrigger] = useState(0);
    const [edittrigger, setEditTrigger] = useState(0);
    const [medfreqval, setMedFreqVal] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleOpenAddModal = () => {
        setMedFreqVal(null);
        setEditTrigger(0);
        setShowModal(true);
    };

    const callAnotherChildMethod = () => {
        setTrigger((prev) => prev + 1);
    };

    const callAnotherEditChildMethod = (editValue) => {
        setMedFreqVal(editValue);
        setEditTrigger((prev) => prev + 1);
        setShowModal(true);
    };

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Drugs-Frequency', href: paths.medFrequency, isActive: true }
    ];

    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            <Row className="g-3 mt-1">
                <Col xs={12}>
                    <Card>
                        <Card.Header className="bg-body-tertiary py-2">
                            <h5 className="mb-0">Frequency</h5>
                        </Card.Header>
                        <Card.Body>
                            <MedFrequencyTable
                                trigger={trigger}
                                onCallEditParent={callAnotherEditChildMethod}
                                onOpenAddModal={handleOpenAddModal}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <EditMedFreqModal
                show={showModal}
                onHide={() => setShowModal(false)}
                medfreqvalue={medfreqval}
                edittrigger={edittrigger}
                onCallParent={callAnotherChildMethod}
            />
        </>
    );
};

export default MedFrequency;

